import React from "react";
import CustomGuage from "./CustomGuage";

const DOOR_TO_NEEDLE_COMPLIANCE_PARTITIONS = [
  {
    label: "Poor",
    value: 60, // 0–59%
    gradient: {
      id: "dtnPoor",
      from: "#C62828", // Medical Red
      to: "#EF5350",
    },
  },
  {
    label: "Average",
    value: 20, // 60–79%
    gradient: {
      id: "dtnAverage",
      from: "#FF8F00", // Amber
      to: "#FFD54F",
    },
  },
  {
    label: "Good",
    value: 20, // 80–100%
    gradient: {
      id: "dtnGood",
      from: "#2E7D32", // Clinical Green
      to: "#66BB6A",
    },
  },
];

function DoorToNeedleCompliance() {
  return (
    <div className="w-full h-full ">
      <CustomGuage
        value={86} // example compliance %
        partitions={DOOR_TO_NEEDLE_COMPLIANCE_PARTITIONS}
        ticks={[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
        showTicks
        showTickLines
        uomPerValue={"%"}
      />
    </div>
  );
}

export default DoorToNeedleCompliance;
